import Manage from '~/api/media';
import { downloadPdf } from '~/services/file_service';
import { getPreviewContent } from '../../services/preview_service';

export default {
    getMediaPreviewPromise({state, commit, getters}, type = null) {
        let params = getters.previewData;
        params = Object.assign({}, getters.previewData, {
            type: type ? type : params.type
        });

        return new Promise((resolve, reject) => {
            Manage.getPreviewData(params).then(response => {
                switch (params.type) {
                    case "pdf":
                        commit('updatePdfPreview', response.preview);
                        break
                    case "html":
                    default:
                        commit('updatePreview', response.preview);
                        break;
                }

                resolve(response);
            }).catch(error => {
                reject(error.message);
            });
        });
    },

    getMediaPreview({state, commit, dispatch}) {
        commit('updateIsLoading', true);

        dispatch('getMediaPreviewPromise').then(response => {
            commit('updateIsLoading', false);
        }).catch(error => {
            commit('triggerError', error);
            commit('updateIsLoading', false);
        }).finally(() => {
            const previewLoadedEvent = new Event('previewLoaded', { bubbles: true });
            document.dispatchEvent(previewLoadedEvent);
        });
    },

    async updatePreviewAssets({state, commit, rootState}) {
        const formData = {
            ...state.formData,
            custom_preview_image: rootState.media.media.custom_preview_image,
            preview_image: state.preview_image
        };

        try {
            const preview = await Manage.updatePreviewAssets(formData);
            return preview;
        } catch(error) {
            throw new Error(error.responseJSON.message);
        }
    },

    downloadPdf({state, rootState}) {
        if (!state.pdfPreview) {
            return;
        }
        downloadPdf(state.pdfPreview, rootState.media.media.name);
    },

    onDownloadPdf({state, commit, dispatch, rootState}) {
        commit('media/creator/silentOpenEditorDialog', null, { root: true });
        commit('updateIsLoading', true);
        dispatch('getMediaPreviewPromise').then(response => {
            setTimeout(() => {
                commit('updatePreviewData', ({
                    content: rootState.media.creator.formData.content,
                    // html comes from the iframe html since we depend on js inside to change the content
                    html: getPreviewContent(),
                    media_id: rootState.media.creator.formData.id
                }));
                dispatch('getMediaPreviewPromise', 'pdf').then(response => {
                    dispatch('downloadPdf');
                    commit('updateIsLoading', false);
                    commit('media/creator/silentCloseEditorDialog', null, {root: true});
                }).catch(error => {
                    commit('triggerError', error);
                    commit('updateIsLoading', false);
                    commit('media/creator/silentCloseEditorDialog', null, {root: true});
                });
            // todo: change the timeout to a promise so we can resolve it without waiting
            }, 1100);
        }).catch(error => {
            commit('triggerError', error);
        });
    }
}